export const DS_SWITCH_CLASSES = {
  Root: "ds-switch",
  InputContainer: "ds-switch__input-container",
  Input: "ds-switch__input",
  Plate: "ds-switch__plate",
  Thumb: "ds-switch__thumb",
  ThumbIcon: "ds-switch__thumb-icon",
  Selected: "ds-switch--selected",
  LabelLeft: "ds-switch--label-left",
  LabelRight: "ds-switch--label-right",
  InputError: "ds-switch__input--error",
  InputSelected: "ds-switch__input--selected",
  PlateError: "ds-switch__plate--error",
  PlateSelected: "ds-switch__plate--selected",
  ThumbSelected: "ds-switch__thumb--selected",
  LabelError: "ds-switch__label--error",
} as const;
